webpackJsonp([14],{

/***/ 526:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f87b417_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(873);
function injectStyle (ssrContext) {
  __webpack_require__(870)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f87b417_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "img/logo.0a5a935.png";

/***/ }),

/***/ 870:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(871);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("ef5c9962", content, true);

/***/ }),

/***/ 871:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".login{height:70vh;text-align:center}.login img{width:100%}.login__col{margin:auto;width:100%;max-width:420px}.login__supertext{font-size:1.4em;text-align:left;margin-bottom:6px}.login__body{margin-top:5em}.login__popover{display:inline;margin-left:.15em;opacity:.4}.login__button{font-size:1em;padding:.8em 2.4em;width:160px;margin:.25em}.login__why-join{margin-top:2em}.login__why-join__link{line-height:1.5;display:inline-block;color:currentColor}", "", {"version":3,"sources":["/app/src/components/Login.vue"],"names":[],"mappings":"AAoHA,OACE,YAAa,AACb,iBAAmB,CACpB,AACD,WACI,UAAY,CACf,AACD,YACE,YAAa,AACb,WAAY,AACZ,eAAiB,CAClB,AACD,kBACE,gBAAiB,AACjB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,aACE,cAAgB,CACjB,AACD,gBACE,eAAgB,AAChB,kBAAoB,AACpB,UAAa,CACd,AACD,eACE,cAAe,AACf,mBAAqB,AACrB,YAAa,AACb,YAAe,CAChB,AACD,iBACE,cAAgB,CACjB,AACD,uBACE,gBAAiB,AACjB,qBAAsB,AACtB,kBAAoB,CACrB","file":"Login.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.login {\n  height: 70vh;\n  text-align: center;\n}\n.login img {\n    width: 100%;\n}\n.login__col {\n  margin: auto;\n  width: 100%;\n  max-width: 420px;\n}\n.login__supertext {\n  font-size: 1.4em;\n  text-align: left;\n  margin-bottom: 6px;\n}\n.login__body {\n  margin-top: 5em;\n}\n.login__popover {\n  display: inline;\n  margin-left: 0.15em;\n  opacity: 0.4;\n}\n.login__button {\n  font-size: 1em;\n  padding: 0.8em 2.4em;\n  width: 160px;\n  margin: 0.25em;\n}\n.login__why-join {\n  margin-top: 2em;\n}\n.login__why-join__link {\n  line-height: 1.5;\n  display: inline-block;\n  color: currentColor;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 872:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_variables__ = __webpack_require__(53);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global BAKED_APPLICATION_VERSION */


/**
 * @param {string} redirectTo
 * @param {'sign_in' | 'sign_up'} authMode
 * @param {Object} authTracker
 * @param {string} authTracker.client
 * @param {string} authTracker.screen_url
 * @param {string} authTracker.intent
 * @returns {string}
 */
var getAuthPopupUrl = function getAuthPopupUrl(redirectTo, authMode, authTracker) {
  var loginURLObj = new URL(__WEBPACK_IMPORTED_MODULE_1__config_variables__["a" /* default */].BASE_URL + '/login');
  loginURLObj.searchParams.append('origin', redirectTo);
  loginURLObj.searchParams.append('reason', btoa(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(authTracker)));
  loginURLObj.searchParams.append('auth_mode', authMode);

  return loginURLObj.href;
};

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    /**
     * @param {'sign_in' | 'sign_up'} authMode
     */
    launchAuthPopup: function launchAuthPopup(authMode) {
      var _this = this;

      var redirectPath = this.$route.query.redirect || '/';
      var loginUrl = getAuthPopupUrl(location.href, authMode, {
        client: 'creator@' + "1.13.8",
        screen_url: location.origin + redirectPath,
        intent: this.$route.query.art_intent || null
      });

      window.popupLoggedIn = function (callback, token) {
        localStorage.setItem('access_token', token);
        _this.$store.dispatch('account/initialiseAccount').then(function () {
          delete window.popupLoggedIn;

          var redirection = _this.$route.query.redirect || '/dashboard';
          _this.$router.push(redirection);
        });
      };
      window.open(loginUrl, 'newwindow', 'width=992,height=600');
    }
  },
  computed: {
    isAuthenticated: function isAuthenticated() {
      return this.$store.state.account.isAuthenticated;
    },
    userName: function userName() {
      var userInfo = this.$store.state.account.blob;
      return userInfo.first_name + ' ' + userInfo.last_name;
    }
  }
});

/***/ }),

/***/ 873:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"login",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('el-col',{staticClass:"login__col"},[_c('div',{staticClass:"login__supertext"},[_vm._v("Welcome to")]),_vm._v(" "),_c('img',{attrs:{"src":__webpack_require__(663)}}),_vm._v(" "),_c('div',{staticClass:"login__body"},[(_vm.isAuthenticated)?_c('div',[_c('p',[_c('strong',[_vm._v("Hi "+_vm._s(_vm.userName)+",")])]),_vm._v(" "),_c('p',[_vm._v("\n          You have already logged in to Viddsee Creator."),_c('br'),_vm._v("\n          Click "),_c('el-button',{attrs:{"type":"text"}},[_c('router-link',{attrs:{"to":"/"}},[_vm._v("here")])],1),_vm._v(" to go to the dashboard.\n        ")],1)]):_c('div',[_c('el-popover',{ref:"loginnotice",attrs:{"placement":"top","title":"Notice for Existing User","width":220,"offset":50,"trigger":"hover","open-delay":2000}},[_vm._v("\n          We moved our email login to a new password-less system for better security.\n          You use your current email address that you previously used to login, and we\n          will send an email to you to proceed with the login.\n        ")]),_vm._v(" "),_c('div',[_c('el-button',{directives:[{name:"popover",rawName:"v-popover:loginnotice",arg:"loginnotice"}],staticClass:"login__button",on:{"click":function($event){_vm.launchAuthPopup('sign_in')}}},[_vm._v("\n            Login\n          ")]),_vm._v(" "),_c('el-button',{staticClass:"login__button",on:{"click":function($event){_vm.launchAuthPopup('sign_up')}}},[_vm._v("Sign up")])],1),_vm._v(" "),_c('div',{staticClass:"login__why-join"},[_c('a',{staticClass:"login__why-join__link",attrs:{"target":"_blank","title":"Open https://www.viddsee.com/join","href":"https://www.viddsee.com/join"}},[_vm._v("\n            Why join?\n          ")])])],1)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// js/14.8bf29c91e3a6046a7cb9.js